import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { CopyText } from "../CopyText";
import { EqualHeightElement } from "../EqualHeight/EqualHeightElement";
import type { ReactDefaultPropsWithChildren } from "../../types/react";

import styles from "./TileImageTeaser.scss";

type TileImageTeaserTileCopyTextBaseProps = {
  customClass?: string;
};

export type TileImageTeaserTileCopyTextProps = TileImageTeaserTileCopyTextBaseProps &
  Omit<
    React.ComponentPropsWithoutRef<"p">,
    keyof TileImageTeaserTileCopyTextBaseProps
  >;

const defaultProps = {
  children: undefined,
  customClass: undefined,
} as const;

const validatedDefaultProps: ReactDefaultPropsWithChildren<
  TileImageTeaserTileCopyTextBaseProps,
  typeof defaultProps
> = defaultProps;

const propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
} as const;

export const TileImageTeaserTileCopyText = ({
  children,
  customClass,
  ...restProps
}: TileImageTeaserTileCopyTextProps): JSX.Element => {
  return (
    <EqualHeightElement name="TileImageTeaserTileCopyText">
      <CopyText customClass={cx(styles.copy, customClass)} {...restProps}>
        {children}
      </CopyText>
    </EqualHeightElement>
  );
};

TileImageTeaserTileCopyText.propTypes = propTypes;

TileImageTeaserTileCopyText.defaultProps = validatedDefaultProps;

TileImageTeaserTileCopyText.displayName = "TileImageTeaser.Tile.CopyText";

export default TileImageTeaserTileCopyText;
